import {
	HttpClient,
	HttpContext,
	HttpContextToken,
	HttpParams,
	HttpParamsOptions,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'projects/access-control/src/environments/environment';

export const HIDE_LOADING = 'hideLoading';

@Injectable({
	providedIn: 'root',
})
export class ApiService {
	constructor(private http: HttpClient) {}

	get<T>(path: string, params: any = {}): Observable<any> {
		return this.http.get<T>(`${environment.apiUrl}${path}`, params);
	}

	put<T>(path: string, body: any, options?: any): Observable<any> {
		return this.http.put<T>(`${environment.apiUrl}${path}`, body, options);
	}

	patch<T>(path: string, body: any, options?: any): Observable<any> {
		return this.http.patch<T>(`${environment.apiUrl}${path}`, body, options);
	}

	post<T>(path: string, body: object, options?: any): Observable<any> {
		return this.http.post<T>(`${environment.apiUrl}${path}`, body, options);
	}

	delete<T>(path: string, body: any): Observable<any> {
		return this.http.delete<T>(`${environment.apiUrl}${path}`, body);
	}

	getFullPath<T>(path: string, params: any = {}): Observable<any> {
		return this.http.get<T>(`${path}`, params);
	}
}

export function customHttpParam(param: any) {
	return new CustomHttpParams(param);
}

class CustomHttpParams extends HttpParams {
	constructor(public params?: { [param: string]: string | string[] }) {
		super({ fromObject: params } as HttpParamsOptions);
	}
}
